import { useState } from 'react';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core/styles';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ReactHtmlParser from 'react-html-parser';
import { useSelector } from 'react-redux';

import Button from '../../Button/Button';
import styles from './SelectOptionItem.module.scss';

const selectedBoxShadow =
  '0px -1px 4px 0px var(--color-gray-shadow), 0px 4px 0px 0px var(--color-main-orange)';

const CustomAccordion = withStyles({
  root: {
    boxSizing: 'border-box',
    margin: '11px 0',
    padding: '0 18px',
    width: '100%',
    border: 'none',
    borderRadius: '11px',
    backgroundColor: 'var(--color-light-gray)',
    boxShadow: '0px 4px 4px var(--color-gray-shadow)',

    '&:hover': {
      cursor: 'pointer',
      // boxShadow:
      // "0px -1px 4px 0px var(--color-gray-shadow), 0px 4px 0px 0px var(--color-main-orange)",
    },

    '&:before': {
      height: '0px',
    },
  },
})(Accordion);

const CustomAccordionSummary = withStyles({
  root: {
    padding: 0,
    margin: 0,
  },

  content: {
    margin: 0,
    '&$expanded': {
      marginBottom: 0,
      marginTop: 0,
      paddingTop: 12,
    },

    '&:hover': {
      cursor: 'inherit',
    },
  },

  expanded: {
    margin: 0,
  },
})(AccordionSummary);

export default function RobotAccordion({
  data,
  selected,
  onClick,
  shouldDisplayPrice,
  displayPrimaryButton,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const robotAccordionTexts = useSelector((store) => store.data.robotAccordion);
  const currentFranchise = useSelector((store) => store.state.city?.franchise);
  const seeMoreLink = `${data.see_more_link}?miasto=${currentFranchise.slug}`;

  const handleOnInfo = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  let additionalAccordionStyles = { cursor: isOpen ? 'auto' : 'pointer' };
  // if (isOpen)
  //   additionalAccordionStyles = {
  //     ...additionalAccordionStyles,
  //     boxShadow: "0px 4px 4px var(--color-gray-shadow)",
  //   };
  if (selected)
    additionalAccordionStyles = {
      ...additionalAccordionStyles,
      boxShadow: selectedBoxShadow,
      backgroundColor: '#fed59e',
    };

  const DescriptionText = ({ value, label }) =>
    value ? <p className={styles.description}>{label + ` ${value}`}</p> : null;

  return (
    <>
      <span></span>
      <CustomAccordion expanded={isOpen} style={additionalAccordionStyles}>
        <CustomAccordionSummary style={isOpen ? { cursor: 'auto' } : {}}>
          <div
            className={styles.robot_container}
            onClick={!isOpen ? onClick : undefined}
          >
            <div className={styles.robot_content}>
              <div
                className={styles.robot_image}
                style={{ backgroundImage: `url('${data.icon}')` }}
              ></div>
              <div className={styles.robot_content_text}>
                <p className={styles.title}>{data.title}</p>
                <DescriptionText
                  value={data.age}
                  label={robotAccordionTexts.description1}
                />
                {shouldDisplayPrice ? (
                  <DescriptionText
                    value={data.price}
                    label={robotAccordionTexts.description2}
                  />
                ) : (
                  ''
                )}
                <DescriptionText
                  value={data.duration}
                  label={robotAccordionTexts.description3}
                />
              </div>
            </div>
            <div className={styles.robot_icon} onClick={handleOnInfo}>
              <div className={styles.robot_icon_container}>
                rozwiń&nbsp;&nbsp;&nbsp;&nbsp;
                <InfoOutlinedIcon fontSize="small" />
              </div>
            </div>
          </div>
        </CustomAccordionSummary>
        <AccordionDetails>
          <div className={styles.accordion_details_container}>
            <p className={styles.accordion_description}>
              {ReactHtmlParser(data.description)}
            </p>
            <div className={styles.accordion_buttons_wrapper}>
              <Button
                type={'secondary'}
                text={robotAccordionTexts.secondary}
                onClick={() => window.open(seeMoreLink, '_blank')}
              />
              {displayPrimaryButton ? (
                <Button
                  type={'primary'}
                  text={robotAccordionTexts.primary}
                  onClick={onClick}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </AccordionDetails>
      </CustomAccordion>
      <span></span>
    </>
  );
}
